module.exports = __webpack_public_path__ + "img/userRes_d.84075303.png";